import { graphql } from '@teachino/shared-infrastructure';
import { courseTopicFragment } from './course-topic.fragment';
import { courseFragment } from '../topic/course.fragment';

export const topicInstancesQuery = graphql(
  `
    query topicInstances($courseId: String!) {
      topicInstances(courseIdInput: { id: $courseId }) {
        ...CourseTopic
      }
      course(courseIdInput: { id: $courseId }) {
        ...Course
      }
    }
  `,
  [courseTopicFragment, courseFragment],
);
